import { Grid, Typography, Box } from "@mui/material"
import { useEffect, useRef, useCallback, useState } from "react"
import Iconify from "../../../components/iconify/Iconify"
import MobileSteps from "../MobileSteps"

import InputForm from "../../forms/InputForm"
import ContainedButton from "../../actions/ContainedButton"
import CeluHeader from "./CeluHeader"
import ShowPasswordBtn from "../../../components/actions/ShowPasswordBtn"


const PasswordView = ({
    loading, stepper,
    passwordForm,
    passwordConfirmationForm,
    onChange,
    onSubmit,
    onReturn
 }) =>{


    const [visible_password, setVisitblePassword] = useState(false)
    const [visible_passwordC, setVisitblePasswordC] = useState(false)
    const [valid, setValid] = useState(false)

    const [rules, setRules] = useState({
        letters:false,
        numbers:false,
        special:false,
        minimum: false,
        match:false
    })

    //const [visivility, setVisivility] = useState(false)

    const passwordRef = useRef()
    const confirmationRef = useRef()

    useEffect(() => {
        if(passwordRef.current) passwordRef.current.focus()
    }, [])


    useEffect(() => {

        const _value = passwordForm.value ?? ''
        const _cmpValue = passwordConfirmationForm.value ?? ''
        const containsMayusAndMins = /^(?=(?:.*[A-Z]){1})(?=(?:.*[a-z]){1})/
        const containsNumbers = /^(?=(?:.*[0-9]){1})/
        const containsSpecials = /[!@#$%^&*(),.?":{}|<>]/

        let _result = {
            letters:_value.match(containsMayusAndMins),
            numbers:_value.match(containsNumbers),
            special:_value.match(containsSpecials),
            minimum: _value?.length > 7,
            match:_cmpValue === _value && passwordForm.isVisited && passwordConfirmationForm.isVisited
        }

        setRules(_result)
        setValid(
            _result.letters && 
            _result.numbers && 
            _result.special && 
            _result.minimum && 
            _result.match 
        )

    }, [passwordForm.value, passwordConfirmationForm.value])


    const onKeyPress = useCallback((event, type)=> {
        if (event.key === 'Enter') {
            switch (type) {
                case 'password':
                    confirmationRef.current.focus()
                    break;
                default:
                    break;
            }
        }
        
    }, [passwordRef, confirmationRef])

    passwordForm.config = {...passwordForm.config, type: visible_password ? 'text' : 'password'}
    passwordConfirmationForm.config = {...passwordConfirmationForm.config, type: visible_passwordC ? 'text' : 'password'}

    return(
        <div >
            <CeluHeader
                title='Crea tu contraseña'
                enable_return onReturn={onReturn} 
            />
            <Box sx={{mt:5}} />
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <InputForm 
                    ref={passwordRef} 
                    data={passwordForm} 
                    onChange={onChange}
                    onKeyPress={(e)=>onKeyPress(e, 'password')}
                    endAdornment={
                        <ShowPasswordBtn
                            show={visible_password}
                            onChange={() => setVisitblePassword(!visible_password)}
                        />
                    } 
                />
                </Grid>
                <Grid item xs={12}>
                    <InputForm 
                    ref={confirmationRef} 
                    data={passwordConfirmationForm} 
                    onChange={onChange}
                    endAdornment={
                            <ShowPasswordBtn
                            show={visible_passwordC}
                            onChange={() => setVisitblePasswordC(!visible_passwordC)}
                        />
                    } />
                </Grid>
            </Grid>
            <div >
                <div style={{padding:'32px 0px'}}>
                    <CheckRequirement 
                        check={rules.letters} 
                        label={'Incluye letras minúsculas y mayúsculas.'} />
                    <CheckRequirement 
                        check={rules.numbers} 
                        label={'Incluye al menos un número.'} />
                    <CheckRequirement 
                        check={rules.special} 
                        label={'Incluye caracteres especiales como &#!$?*.'} />
                    <CheckRequirement 
                        check={rules.minimum} 
                        label={'Contiene al menos 8 caracteres.'} />
                    <CheckRequirement 
                        check={rules.match} 
                        label={'Ambas contraseñas coinciden.'} />
                </div>
            </div>
            <MobileSteps
                position={stepper?.position ?? 0}
                steps={stepper?.steps ?? 1}
            />
            <ContainedButton fullWidth
            disabled={!valid} 
            loading={loading}
            onClick={onSubmit}
            >¡Listo!</ContainedButton>
        </div>
    )

}

export default PasswordView

const CheckRequirement = ({check, label}) => {

    return(
        <Box 
        >
            <Grid container wrap="nowrap" >
                <Grid item>
                    <Iconify 
                        icon={check ? 'material-symbols:check' : 'ic:round-close'}
                        color={check ? '#96AE76' :  '#D95D71'}
                        width={24}
                        sx={{mt:0.4, mr:1}}
                    />
                </Grid>
                <Grid item xs>
                    <Typography  style={{fontWeight: check ? 600 : 500}} >{label}</Typography>
                </Grid>
            </Grid>
        </Box>
    )
}